import React from "react";

export function BookCover({ product, className = "" }) {
  if (product.cover_image) {
    return (
      <div className={`relative overflow-hidden rounded-xl shadow-2xl ${className}`} style={{ aspectRatio: "2/3" }}>
        <img src={product.cover_image} alt={product.title} className="h-full w-full object-cover" loading="lazy" />
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-slate-950/90 to-transparent p-3">
          <div className="text-xs font-bold text-white leading-tight">{product.title}</div>
          <div className="text-[10px] text-cyan-300">{product.author}</div>
        </div>
      </div>
    );
  }
  const g = product.cover?.g || "from-blue-600 via-cyan-600 to-teal-600";
  const accent = product.cover?.accent || "#22d3ee";
  return (
    <div
      className={`relative overflow-hidden rounded-xl bg-gradient-to-br ${g} shadow-2xl ${className}`}
      style={{ aspectRatio: "2/3" }}
    >
      <div className="absolute inset-0 opacity-20" style={{ background: "radial-gradient(circle at 30% 20%, rgba(255,255,255,0.4), transparent 55%)" }} />
      <div className="absolute left-0 top-0 h-full w-1.5 bg-black/30" />
      <div className="flex h-full flex-col justify-between p-3 pl-5">
        <div className="text-[9px] font-semibold uppercase tracking-widest" style={{ color: accent }}>
          {product.format === "audiobook" ? "Audiobook" : "Ebook"}
        </div>
        <div>
          <div className="text-sm font-extrabold leading-snug text-white font-display">{product.title}</div>
          <div className="mt-1 text-[10px] font-medium text-white/80">{product.author}</div>
        </div>
        <div className="text-[9px] font-bold tracking-wider text-white/70">DigiLib.store</div>
      </div>
    </div>
  );
}
